import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloQualita } from '@/mocks/articles';

export default function QualitaPage() {
  return <ArticleLayout article={articoloQualita} />;
}